import React, { FC } from 'react';
import { ActionBar, ActionBarProps } from 'ia-react-core';

export interface MfaActionBarProps extends ActionBarProps {}

const MfaActionBar: FC<MfaActionBarProps> = (props) => (
  <ActionBar minButtonWidth="calc(100% - 16px)" {...props} />
);

export default MfaActionBar;
